import { useTranslate } from '@tolgee/react';
import { ChannelIcon } from 'views/Conversation/ConvList/ChannelIcon';
import { HeaderItemBox } from './HeaderItemBox';
import { Tooltip } from 'antd';
import { CopyText } from './CopyText';
import { platformLabelMap } from 'services/config/platform';
import toLowerCase from 'utils/toLowerCase';
import { SquareArrowOutUpRight } from 'lucide-react';
import { cx } from '@emotion/css';
import { getSellerCenterURL, isSupportSellerCenterURL } from 'utils/sellerCenterURL';

interface HeaderStoreInfoProps {
  channel: Conversation.Conversation['channel'];
  region: Conversation.Conversation['region'];
  storeName: Conversation.Conversation['storeName'];
  storeAlias: Conversation.Conversation['storeAlias'];
  storeType?: Conversation.TopBarInfo['storeType'];
  storeId: Conversation.Conversation['storeId'];
}

const StoreTypeText = (props: { storeType: Conversation.TopBarInfo['storeType'] }) => {
  const { storeType } = props;
  const { t } = useTranslate();
  if (storeType === 'LOCAL') {
    return <HeaderItemBox>{t('店铺类型枚举.LOCAL')}</HeaderItemBox>;
  }

  if (storeType === 'CROSS') {
    return <HeaderItemBox>{t('店铺类型枚举.CROSS')}</HeaderItemBox>;
  }

  return null;
};

interface StoreNameProps {
  channel: Conversation.Conversation['channel'];
  storeId: Conversation.Conversation['storeId'];
  storeName?: string;
  storeAlias?: string;
}

const StoreName = (props: StoreNameProps) => {
  const { channel, storeId, storeName, storeAlias } = props;
  const { t } = useTranslate();

  const storeNameText = storeAlias || storeName;

  if (!storeNameText) {
    return null;
  }

  const title = (
    <div className="flex flex-col gap-3">
      {storeAlias ? (
        <div>
          <div>{t('ViewShops.店铺别名')}</div>
          <CopyText text={storeAlias} showIcon keepIcon />
        </div>
      ) : null}
      {storeName ? (
        <div>
          <div>{t('ViewShops.店铺名称')}</div>
          <CopyText text={storeName} showIcon keepIcon />
        </div>
      ) : null}
    </div>
  );

  return (
    <div className="flex group items-center gap-[1px] min-w-0 cursor-pointer relative">
      <Tooltip title={title}>
        <span
          className="text-[#515359] truncate flex-shrink-1 flex-grow-0 min-w-0"
          title={storeNameText}
        >
          {storeNameText}
        </span>
      </Tooltip>
      {isSupportSellerCenterURL(channel) ? (
        <Tooltip title={t('前往卖家中心')}>
          <SquareArrowOutUpRight
            size={14}
            className={cx(
              'text-[#84868C] flex-shrink-0 hidden group-hover:inline-flex absolute top-[4px] right-0 bg-[#EEF0F3]',
            )}
            onClick={() => getSellerCenterURL(channel, storeId)}
          />
        </Tooltip>
      ) : null}
    </div>
  );
};

export const HeaderStoreInfo = (props: HeaderStoreInfoProps) => {
  const { channel, region, storeName, storeAlias, storeType, storeId } = props;
  const { t } = useTranslate();
  return (
    <div className="flex items-center gap-2 flex-grow-0 flex-shrink-1 min-w-0">
      <Tooltip title={platformLabelMap[toLowerCase(channel)]}>
        <span className="w-[20px] h-[20px] flex items-center justify-center bg-[#FFFFFF] rounded-[2px] flex-shrink-0">
          <ChannelIcon className="w-3 h-3" channel={channel} />
        </span>
      </Tooltip>
      <Tooltip title={t(`region.${toLowerCase(region)}`)}>
        <HeaderItemBox>{region.toUpperCase()}</HeaderItemBox>
      </Tooltip>
      {storeType && <StoreTypeText storeType={storeType} />}
      <StoreName
        channel={channel}
        storeId={storeId}
        storeName={storeName}
        storeAlias={storeAlias}
      />
    </div>
  );
};
